import React from 'react';
import clsx from 'clsx';
import Form from 'react-bootstrap/Form';

import styles from './Radio.module.scss';

interface Props {
  label?: React.ReactNode;
  size?: 'small' | 'medium' | 'large';
  className?: string;
  checked?: boolean;
  onChange: (_checked: boolean) => void;
  name?: string;
  testId?: string;
}

const Radio = ({
  label,
  size = 'small',
  className,
  checked,
  onChange,
  name,
  testId,
}: Props) => (
  <Form.Check.Label
    className={clsx(
      'd-flex align-items-center text-main',
      label && 'pe-2a',
      styles['radio-container'],
      styles[size],
      className,
    )}
  >
    <Form.Check.Input
      name={name}
      onChange={() => onChange(!checked)}
      checked={!!checked}
      className={clsx('mt-0 me-2a flex-shrink-0 rounded-circle', styles.radio)}
      type="radio"
      data-testid={testId}
    />
    {label}
  </Form.Check.Label>
);

export default Radio;
